import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatcode'
})
export class FormatcodePipe implements PipeTransform {

  transform(value: string, defaultValue: string = '-'): string {
    if (!value) {
      return defaultValue;
    }

    const regex = /^[a-zA-Z]/;
    if (!regex.test(value)) {
      const strValue = value.toString();
      const length = strValue.length;
      
      if (length > 6) {
        // Si es mayor a 6, devolvemos el valor original
        return strValue;
      }
      
      // Calculamos cuántos ceros necesitamos (6 - longitud)
      const zeros = '000000'.substring(0, 6 - length);
      return zeros + strValue;
    } 
    
    return value;
  }
}
